module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMoLgn8TwlmGDVg1IBRA4aLAQA/ATcfkb0BpAAAAABJRU5ErkJggg=="